import { useEffect, useState } from "react";
import Loader from "../basic/Loader";
import Modal from "../layout/Modal";
import Button from "../basic/Button";
import "../../styles/help.scss";
import IconHelp from "../../images/icon-help.png";
import useLanguage, { T } from "../../hooks/useLanguage";
import { useModal } from "../../hooks/useModal";
import InputCheckbox from "../basic/InputCheckbox";
import { useContact, useLocals, useUser } from "../../hooks/useApi";
import useGeoLocation from "../../hooks/useGeoLocation";

export default function HelpModal() {
  const { i18n } = useLanguage();
  const { closeModal } = useModal();
  const { user, getRadioInfo } = useUser();
  const {
    isLoading,
    mutate: submit,
    isSuccess,
    data: submitData,
    reset: resetSubmit,
  } = useContact();
  const { lat, lng } = useGeoLocation();
  const { data: locals } = useLocals(lat, lng);
  const [formData, setFormData] = useState({
    subject: "",
    message: "",
    email: "",
    notifications: true,
    radio: "",
  });

  useEffect(() => {
    if (user?.email) {
      setFormData((prev) => ({ ...prev, email: user.email }));
    }
  }, [user]);

  const handleSubmit = () => {
    submit({
      token: user?.token ? user.token : "",
      email: formData.email,
      type: "help",
      msg: JSON.stringify({ subject: formData.subject, complaintRadio: formData.radio, message: formData.message, notifications: formData.notifications }),
      radio: JSON.stringify(getRadioInfo()),
    });
  };

  useEffect(() => {
    debugger;
    if (locals && locals.length > 0 && formData.radio === "") {
      setFormData((prev) => ({ ...prev, radio: locals[0]?.name }));
    }
  }, [locals]);

  useEffect(() => {
    if (isSuccess) {
      // console.log("submitData", submitData);
      if (submitData?.data?.data?.msg) {
        alert(submitData.data.data.msg);
      } else if (submitData?.data?.msg) {
        alert(submitData.data.msg);
      } else if (submitData?.msg) {
        alert(submitData.msg);
      }
      resetSubmit();
      closeModal();
    }
  }, [isSuccess, closeModal, submitData, resetSubmit]);

  return (
    <Modal disableClose={true} className="help-modal">
      <form style={{ width: "100%", textAlign: "center" }} onSubmit={(e) => { e.preventDefault(); handleSubmit(); }}>
        <Button
          onClick={closeModal}
          className="button-cancel"
          style={{ marginLeft: 10 }}
        >
          &times;
        </Button>
        <img src={IconHelp} alt="help" className="header-icon" />
        <h1>
          <T>help.title</T>
        </h1>
        <p>
          <T>help.subtitle</T>
        </p>
        <input
          type="text"
          placeholder={i18n.t("help.subject")}
          value={formData.subject}
          onChange={(e) => setFormData((prev) => ({ ...prev, subject: e.target.value }))}
          required
        />
        <label htmlFor="help-category"><T>help.radio</T></label>
        <select
          id="help-category"
          value={formData.radio}
          required
          style={{ marginBottom: "1rem" }}
          onChange={(e) => setFormData((prev) => ({ ...prev, radio: e.target.value }))}
        >
          {locals && locals.length > 0 && (
            locals.map((local) => (
              <option key={local.radioid} value={local.name}>
                {local.name}
              </option>
            ))
          )}
        </select>
        <textarea
          placeholder={i18n.t("help.message")}
          value={formData.message}
          onChange={(e) => setFormData((prev) => ({ ...prev, message: e.target.value }))}
          required
          style={{ resize: "vertical", minHeight: "50px" }}
        />
        <p className="notifications">
          <T>help.notifications</T>
        </p>
        <InputCheckbox
          input={{
            type: "email",
            value: formData.email,
            onChange: (e) => setFormData((prev) => ({ ...prev, email: e.target.value })),
          }}
          checkbox={{
            checked: formData.notifications,
            onChange: (e) => setFormData((prev) => ({ ...prev, notifications: e.target.checked })),
          }}
        />
        <Button className="brand" type="submit">
          {isLoading ? <Loader /> : <T>send</T>}
        </Button>
      </form>
    </Modal>
  );
}
